import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuOption } from '@app/core/models/menu-option.model';
import { AuthenticationService } from '@app/core/services/authentication.service';
import { MenuService } from '@app/core/services/menu.service';
import { SaveObjectInLocalServiceService } from '@app/core/services/save-object-in-local-service.service';

@Component({
  selector: 'dhl-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent {
  isEnableOption: boolean = true;
  menuOptions: MenuOption[] = [
    {
      menuId: '1',
      menuName: 'Example',
      url: 'ruta/lugar',
      permissions: [],
      // menuChildId: null,
      submenu: [],
      icon: 'qwerty',
      order: 1
    },
    {
      menuId: '2',
      menuName: 'Example',
      url: 'ruta/lugar',
      permissions: [],
      // menuChildId: null,
      submenu: [],
      icon: 'qwerty',
      order: 2
    }
  ];

  opcionesmenu = [
    { nombre: 'option1', seleccionada: false },
    { nombre: 'option2', seleccionada: false },
    { nombre: 'option3', seleccionada: false },
    { nombre: 'option4', seleccionada: false }
  ];

  isVisibleLogoutModal: boolean = false;
  isEnableMenu: boolean = true;
  @ViewChild('menu', { static: false }) checkmenu!: ElementRef<HTMLInputElement>;

  constructor(
    private readonly router: Router,
    private readonly location: Location,
    private readonly authService: AuthenticationService,
    private readonly storage: SaveObjectInLocalServiceService,
    private readonly menuService: MenuService
  ) {}

  deseleccionarMenusChecks(indice: number) {
    if (this.opcionesmenu[indice].seleccionada) {
      this.hiddenMenusToggle(indice, false);
    }
  }

  hiddenMenusToggle(indice: number, hiddenAll: boolean) {
    if (!hiddenAll) {
      this.opcionesmenu.forEach((opcion, index) => {
        if (indice !== index) {
          opcion.seleccionada = false;
        }
      });
    } else {
      this.opcionesmenu.forEach((opcion) => {
        opcion.seleccionada = false;
      });
    }
  }

  showModalLogout() {
    this.isVisibleLogoutModal = true;
  }

  hiddenMenu(isOptionOfToggle: boolean) {
    this.checkmenu.nativeElement.checked = false;
    /**
     * Le pasamos como indice 0 y parametro true ya que
     * solamente requerimos que quite todos los toggle menu
     */
    if (!isOptionOfToggle) {
      this.hiddenMenusToggle(0, true);
    }
  }
}
